<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Update Zone</h2>
            </div>
        </div>
        <a-card v-if="zone">
            <a-form :form="form"  @submit="handleSubmit">
                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Name">
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }],
                                    initialValue: zone.name }]"
                                placeholder="Enter name"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Area">
                            <a-select size="large"
                                show-search
                                :filter-option="filterOption"
                                v-decorator="[
                                'area_id',
                                { rules: [{ required: true, message: 'Please select area!' }],
                                    initialValue: zone.area.id }]"
                                placeholder="Select area"
                            >
                                <template v-if="zone.area && zone.area.id && zone.area.status === 0">
                                    <a-select-option :key="zone.area.id" :value="zone.area.id">
                                        {{zone.area.name}}
                                    </a-select-option>
                                </template>
                                <template v-for="area in areas">
                                    <a-select-option :key="area.id" :value="area.id">
                                        {{area.name}}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Hub">
                            <a-select size="large"
                                show-search
                                :filter-option="filterOption"
                                v-decorator="[
                                'hub_id',
                                { rules: [{ required: true, message: 'Please select Hub!' }],
                                    initialValue: zone.hub.id }]"
                                placeholder="Select hub"
                            >
                                <template v-if="zone.hub && zone.hub.id && zone.hub.status === 0">
                                    <a-select-option :key="zone.hub.id" :value="zone.hub.id">
                                        {{zone.hub.name}}
                                    </a-select-option>
                                </template>
                                <template v-for="hub in hubs">
                                    <a-select-option :key="hub.id" :value="hub.id">
                                        {{hub.name}}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Post Code">
                            <a-input size="large"
                                v-decorator="['post_code', { rules: [{ required: false }],
                                    initialValue: zone.post_code }]"
                                placeholder="Enter Post code"
                            />
                        </a-form-item>
                    </a-col>

                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Status">
                            <a-select size="large"
                                v-decorator="[
                                'status',
                                { rules: [{ required: true, message: 'Please select Status!' }],
                                    initialValue: zone.status },
                                ]"
                                placeholder="Select Status"
                            >
                                <a-select-option :value="1">
                                Active
                                </a-select-option>
                                <a-select-option :value="0">
                                Inactive
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="24">
                        <a-form-item label="Coordinates">
                            <a-input size="large" disabled
                                v-decorator="['coordinates', { rules: [{ required: true, message: 'Please Enter Coordibates' }],
                                initialValue: edited ? edited : undefined }]"
                                placeholder="Enter Coordibates"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- <div class="py-5 px-5">
                    <gmap-map :center="center" :zoom="15" style="width: 100%; height: 500px" ref="map">
                        <gmap-polygon v-if="paths.length > 0" :paths="paths" :editable="true" @paths_changed="updateEdited($event)"
                            @rightclick="handleClickForDelete"
                            ref="polygon">
                        </gmap-polygon>
                        </gmap-map>

                        <div>
                        <button @click="addPath()">Add Path</button>
                        <button @click="removePath()">Remove Path</button>
                    </div>
                </div> -->

                <div class="py-5 px-5">
                    <gmap-map :center="center" :zoom="12" style="width: 100%; height: 500px">
                        <gmap-polygon :paths="prevousPaths" :editable="false"
                            :options="optionsPre">
                        </gmap-polygon>

                        <gmap-polygon :paths="paths" :editable="true" :options="optionsEdit"
                         @paths_changed="updateEdited($event)">
                        </gmap-polygon>
                    </gmap-map>
                </div>

                <a-form-item >
                    <a-button type="primary" size="large" class="btn btn-xs" html-type="submit">
                        Update Zone
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
        <a-card v-else>
            <h4>Zone not find</h4>
        </a-card>
    </div>
</template>

<script>
import { AREA_LIST, HUB_LIST, ZONE_LIST, ZONE_UPDATE } from "../../../script/api";
import { getData, postData } from "../../../script/api-service";
import {alertPop} from "../../../script/helper";

export default {
    props: ['zoneId'],
    data: () => ({
        center: {lat: 23.755, lng: 90.397},
        edited: null,
        paths: [
            [ {lat: 23.750, lng: 90.387}, {lat: 23.750, lng: 90.397}, {lat: 23.760, lng: 90.397}, {lat: 23.760, lng: 90.387} ],
        ],
        areas: [],
        hubs: [],
        zone: null,
        optionsEdit: {
            strokeColor: "#0000ff",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#0000ff",
            draggable: true,
        },
        optionsPre: {
            strokeColor: "#ff3737",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#ff3737",
            draggable: false,
        },
        prevousPaths: []
    }),
    methods: {
        updateEdited(mvcArray) {
            let paths = [];
            for (let i=0; i<mvcArray.getLength(); i++) {
                let path = [];
                for (let j=0; j<mvcArray.getAt(i).getLength(); j++) {
                let point = mvcArray.getAt(i).getAt(j);
                path.push({lat: point.lat(), lng: point.lng()});
                }
                paths.push(path);
            }

            let coordinates = paths[0],
                lat = 0,
                lng = 0;

            coordinates.forEach(e => {
                lat = lat + e.lat;
                lng = lng + e.lng;
            });

            this.center = { 
                lat: lat / coordinates.length, 
                lng: lng / coordinates.length
            }
            coordinates.push(coordinates[0])
            this.edited = JSON.stringify(coordinates);
        },
        handleSubmit(e) {
            e.preventDefault();

            this.form.validateFields(async (err, values) => {
                if (!err) {
                    values.center = [this.center];
                    values.coordinates = JSON.parse(values.coordinates);

                    if (values.name === this.zone.name) delete values.name;
                    values.zone_id = this.zoneId;
                    
                    let res = await postData(ZONE_UPDATE, values);

                    if (res) {
                        alertPop("success", "Zone Updated Successfully");
                    }
                }
            });
        },
        async getAreas() {
            let res = await getData(AREA_LIST + '?status=1');

            if (res) {
                let masterData = res.data?.data;
                this.areas = masterData;
            }
        },
        async getHubs() {
            let res = await getData(HUB_LIST + '?status=1');

            if (res) {
                let masterData = res.data?.data;
                this.hubs = masterData;
            }
        },
        async getZones() {
            let res = await getData(ZONE_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.zone = masterData.find(e => e.id == this.zoneId);

               let path = [];
                masterData.forEach(data => {
                    if (data.id != this.zoneId) path.push(data.coordinates.path);
                });
                this.prevousPaths = path;
                

                if (this.zone) {
                    this.edited = this.zone.coordinates && this.zone.coordinates.path && this.zone.coordinates.path.length ? JSON.stringify(this.zone.coordinates.path) : null;

                    this.paths = this.zone.coordinates && this.zone.coordinates.path && this.zone.coordinates.path.length ? this.zone.coordinates.path : this.paths;
                    this.center = this.zone.coordinates && this.zone.coordinates.center ? this.zone.coordinates.center : this.center;
                }
            }
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: "create_role" });
    },
    mounted() {
        this.getZones();
        this.getAreas();
        this.getHubs();
    },
}
</script>